import { render, staticRenderFns } from "./tab_user.vue?vue&type=template&id=56af3b98&scoped=true&"
import script from "./tab_user.vue?vue&type=script&lang=js&"
export * from "./tab_user.vue?vue&type=script&lang=js&"
import style0 from "./tab_user.vue?vue&type=style&index=0&id=56af3b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af3b98",
  null
  
)

export default component.exports